// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"418":"7634eb4f","486":"7f977ed9","488":"1a77fca7","782":"87dc8ed5","810":"49b390f8"}[chunkId] + ".chunk.css";
};